import { Directive,HostListener, ElementRef, Input } from '@angular/core';
import{UpperCasePipe, LowerCasePipe} from '@angular/common'

@Directive({
  selector: '[ngUppercaseLowercase]',
  providers: [UpperCasePipe, LowerCasePipe]
})
export class NgUppercaseLowercaseDirective  {
  private el: any;
  @Input() tipo: string;
   
  constructor(
    private elementRef:ElementRef,
    private upperCase:UpperCasePipe,
    private lowerCase: LowerCasePipe) {
      this.el = this.elementRef.nativeElement;
    }
  @HostListener("keyup", ["$event.target.value"])
  onKeyDown(value) {
    if(this.tipo == 'uppercase')
      this.el.value = this.upperCase.transform(value);
    if(this.tipo == 'lowercase')
      this.el.value = this.lowerCase.transform(value);
  }
  
  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    if(this.tipo == 'uppercase')
      this.el.value = this.upperCase.transform(value);
    if(this.tipo == 'lowercase')
      this.el.value = this.lowerCase.transform(value);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/element/ng-uppercase-lowercase.directive.ts